import React from "react";
import styled from "@emotion/styled";

import {
  Card as MuiCard,
  CardContent as MuiCardContent,
  Grid,
  Typography as MuiTypography,
  Switch,
  IconButton as MuiIconButton,
} from "@mui/material";
import { Bookmarks as BookmarkIcon } from "@mui/icons-material";
import { Box, spacing, SpacingProps } from "@mui/system";
import NoResultsFound from "../NoResultsFound";
import QueryResultCard from "../search/QueryResultCard";
import { RootState } from "../../../redux/store";
import { useParams } from "react-router-dom";
import { QueryResult } from "../../../types/app";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { setBookmarkDialogState } from "../../../redux/slices/bookmark";
import useAppSelector from "../../../hooks/useAppSelector";

const Card = styled(MuiCard)`
  width: 345px;
  margin-top: 13px;
  margin-left: 20px;
  border-radius: 15px;
  box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.4);
`;

const CardContent = styled(MuiCardContent)`
  border-bottom: 1px solid ${(props) => props.theme.palette.grey[300]};
  height: 100px;
`;

const QueryContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SwitchContainer = styled.div`
  display: flex;
  margin-left: 40px;
`;

const DocText = styled(MuiTypography)`
  margin-top: 10px;
  font-size: 11px;
`;

const IconButton = styled(MuiIconButton)`
  &:hover {
    background-color: transparent;
  }
`;

interface TypographyProps extends SpacingProps {
  component?: string;
}
const Typography = styled(MuiTypography)<TypographyProps>(spacing);

function SidebarResults() {
  const dispatch = useAppDispatch();
  const searchState = useAppSelector((state: RootState) => state.search);
  const queryResult = searchState.queryResult;
  const [currentPDF, setCurrentPDF] = React.useState<boolean>(false);
  const { pdfId } = useParams<{ pdfId: string }>();

  return (
    <React.Fragment>
      {queryResult.length !== 0 ? (
        <Box>
          <Card>
            <CardContent>
              <QueryContainer>
                <Box display="flex">
                  <Typography variant="h5" sx={{ marginTop: "8px" }}>
                    Query
                  </Typography>
                  <IconButton
                    onClick={() => dispatch(setBookmarkDialogState(true))}
                  >
                    <BookmarkIcon sx={{ fontSize: "17px" }} />
                  </IconButton>
                </Box>
                <SwitchContainer>
                  <DocText>All Doc</DocText>
                  <Switch
                    checked={currentPDF}
                    onChange={() => setCurrentPDF(!currentPDF)}
                  />
                  <DocText>Curr Doc</DocText>
                </SwitchContainer>
              </QueryContainer>
              <Typography mb={4} color="textSecondary" component="p">
                {searchState.searchQuery}
              </Typography>
            </CardContent>
          </Card>

          <Grid container spacing={3} marginTop="3px" marginLeft="8px">
            {queryResult
              .filter((query) => (currentPDF ? query.pdfName === pdfId : true))
              .map((item: QueryResult) => {
                return (
                  <Grid item xl={12} key={item.rank}>
                    <QueryResultCard
                      width={345}
                      rank={item.rank}
                      description={item.description}
                      summary={item.summary}
                      answer={item.answer}
                      pdfName={item.pdfName}
                      page={item.page}
                      score={item.score}
                      cluster={item.cluster}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </Box>
      ) : (
        <NoResultsFound />
      )}
    </React.Fragment>
  );
}

export default SidebarResults;
